import { v4 as uuidv4 } from 'uuid';
import { JSONSchema7 } from 'json-schema';
import ControlKind from '../../../Shared/controlKind';
import { GridSize } from '../../../Shared/Enums/gridSize';

export default (controlId: string, pageExternalId: string, order: number) => {
  return {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: `#${pageExternalId}/${controlId}`,
    type: 'object',
    properties: {
      version: {
        $id: `#${pageExternalId}/${controlId}/version`,
        default: 5,
        type: 'number'
      },
      label: {
        $id: `#${pageExternalId}/${controlId}/label`,
        default: 'Numeric Field',
        type: 'string'
      },
      id: {
        $id: `#${pageExternalId}/${controlId}/id`,
        default: `${uuidv4().replace(/-/g, '')}`,
        type: 'string'
      },
      value: {
        $id: `#${pageExternalId}/${controlId}/value`,
        default: 0,
        type: 'number'
      },
      type: {
        $id: `#${pageExternalId}/${controlId}/type`,
        default: ControlKind.NUMERIC,
        type: 'string'
      },
      required: {
        $id: `#${pageExternalId}/${controlId}/required`,
        default: false,
        type: 'boolean'
      },
      minimum: {
        $id: `#${pageExternalId}/${controlId}/minimum`,
        default: 0,
        type: 'number'
      },
      maximum: {
        $id: `#${pageExternalId}/${controlId}/maximum`,
        default: 100,
        type: 'number'
      },
      decimalPlaces: {
        $id: `#${pageExternalId}/${controlId}/decimalPlaces`,
        default: 2,
        type: 'number'
      },
      order: {
        $id: `#${pageExternalId}/${controlId}/order`,
        default: order,
        type: 'integer'
      },
      conditional: {
        $id: `#${pageExternalId}/${controlId}/conditional`,
        default: false,
        type: 'boolean'
      },
      utilizeHiddenComponents: {
        $id: `#${pageExternalId}/${controlId}/utilizeHiddenComponents`,
        default: false,
        type: 'boolean'
      },
      rules: {
        $id: `#${pageExternalId}/${controlId}/rules`,
        type: 'array',
        minItems: 1,
        maxItems: 10,
        default: []
      },
      gridSize: {
        $id: `#${pageExternalId}/${controlId}/gridSize`,
        default: GridSize.FULL,
        type: 'number'
      }
    }
  } as JSONSchema7;
};
